// extracted by mini-css-extract-plugin
export default {"backdrop":"layout_backdrop__ZKOXd"};